<div class="container">
  <div class="container-start">
    <h1 class="start-title">Bienvenido a Inicio</h1>
    <a [routerLink]="'/'" class="back-button"
      ><div class="container-button">
        <img src="assets/img/logo_icono.png" alt="" />
        <p style="margin: 0">Ir al Panel de Control</p>
      </div>
    </a>
  </div>
</div>
